import { useAssistantState } from '@assistant-ui/react';

import { AIChatDataTypes, SuspendedToolCallData } from '@atom/types/ai';

type UseSuspendedPickerResponse = {
  suspended: SuspendedToolCallData | null;
  isLast: boolean;
};

export const useSuspendedPicker = (): UseSuspendedPickerResponse => {
  const message = useAssistantState(state => state.message);
  const isLast = useAssistantState(state => state.message.isLast);

  const part = message.content.find(
    (contentPart: any) =>
      contentPart.type === 'data' &&
      contentPart.name === AIChatDataTypes.TOOL_CALL_SUSPENDED,
  );

  return {
    suspended: part ? ((part as any).data as SuspendedToolCallData) : null,
    isLast,
  };
};
